import { render, staticRenderFns } from "./MobileUpdate.vue?vue&type=template&id=49df36d9&scoped=true&"
import script from "./MobileUpdate.vue?vue&type=script&lang=js&"
export * from "./MobileUpdate.vue?vue&type=script&lang=js&"
import style0 from "./MobileUpdate.vue?vue&type=style&index=0&id=49df36d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49df36d9",
  null
  
)

export default component.exports